import { CaseDetails } from '../../CaseDetailsPage.types';
import { Nullable } from 'utils/types';
import { FIELDS } from 'modules/cm/fields/types';

export type AssurancePolicy = {
  id: number;
  [FIELDS.ASSURANCE_POLICY_ASSURED_PERSON]: Nullable<string>;
  [FIELDS.ASSURANCE_POLICY_TYPE]: Nullable<string>;
  [FIELDS.ASSURANCE_POLICY_EXPIRY_DATE]: Nullable<string>;
  [FIELDS.ASSURANCE_POLICY_PAYMENTS_PER_ANNUM]: Nullable<number>;
  [FIELDS.ASSURANCE_POLICY_BASIS_OF_COVER]: Nullable<string>;
  [FIELDS.ASSURANCE_POLICY_INSURANCE_LUMP_SUM]: Nullable<number>;
  [FIELDS.ASSURANCE_POLICY_MONTHLY_PAYMENT]: Nullable<number>;
  [FIELDS.ASSURANCE_POLICY_MORTGAGE_MONTHLY_PAYMENTS]: Nullable<number>;
};

export type Props = {
  data: AssurancePolicy[];
  initialData: AssurancePolicy[];
  resources: CaseDetails['resources'];
  caseId: string;
};

export enum POLICY_TYPES {
  DECREASING_TERM_ASSURANCE = 'DECREASING_TERM_ASSURANCE',
  LEVEL_TERM_ASSURANCE = 'LEVEL_TERM_ASSURANCE',
  FAMILY_INCOME_BENEFIT = 'FAMILY_INCOME_BENEFIT',
  WHOLE_OF_LIFE = 'WHOLE_OF_LIFE',
}
